import "./Contact.css";

function Contact() {
  return (
    <div className="lp-page">

      <div className="lp-hero">
        <div className="lp-hero-tag">✉️ Contact</div>
        <h1>Get in Touch</h1>
        <p>Questions, feedback, bug reports, or just want to say hi — we're here.</p>
      </div>

      <div className="lp-container">

        <div className="lp-section">
          <h2>Email Us</h2>
          <p>
            The best way to reach the Learnlia team is by email.
            We typically respond within 24–48 hours.
          </p>
          <div className="lp-callout">
            <strong>learnliadev@gmail.com</strong>
            <br />
            <a
              href="mailto:learnliadev@gmail.com"
              style={{ color: "var(--accent)", fontSize: "13px" }}
            >
              Send an email →
            </a>
          </div>
        </div>

        <div className="lp-section">
          <h2>What to Include</h2>
          <p>To help us respond faster, please mention:</p>
          <ul>
            <li>Your registered email address (if account-related)</li>
            <li>A clear description of your question or issue</li>
            <li>Any screenshots if you're reporting a bug</li>
          </ul>
        </div>

        <div className="lp-section">
          <h2>Feedback & Feature Requests</h2>
          <p>
            Learnlia is actively being improved. If you have an idea for a feature,
            something that felt confusing, or something you loved — we genuinely want
            to hear it. Early feedback shapes the product.
          </p>
        </div>

        <div className="lp-section">
          <h2>Response Time</h2>
          <p>
            We're a small team building in public. We'll get back to you as quickly
            as we can — usually within a day or two.
          </p>
        </div>

      </div>
    </div>
  );
}

export default Contact;